module.exports = __webpack_public_path__ + "images/landing/light/pattern-light-landing-bottom.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/light/pattern-light-landing-bottom.svg
// module id = nNID
// module chunks = 151